import ReactEcharts from "echarts-for-react"

export default function CusGaugeChart({
    gaugeChartData,
    intervalList
}){

    const colorList = [
        "#5470C6",
        "#91cc75",
        "#fac858",
        "#ee6666",
        "#73c0de",
        "#3ba272",
        "#fc8452",
        "#9a60b4",
        "#ea7ccc",
      ]
      const options = {
        series: [
          {
            type: "gauge",
            startAngle: 180,
            endAngle: 0,
            center: ["50%", "80%"],
            radius: "130%",
            min: 0,
            max: 27,
            axisLine: {
              lineStyle: {
                width: 50,
                color: intervalList.map((interval, index) => {
                  return [interval, colorList[index]]
                }),
              },
            },
            progress: {
              itemStyle: {
                borderRadius: 10,
                borderColor: "#fff",
                borderWidth: 2,
              },
            },
            axisLabel: {
              show: false,
            },
            splitLine: {
              show: false,
            },
            axisTick: {
              show: false,
            },
            detail: {
              show: false,
            },
            pointer: {
              itemStyle: {
                color: "gray",
              },
            },
            data: gaugeChartData,
          },
        ],
      }
      
    return (
        <ReactEcharts option={options} style={{ height: "300px", width: "100%" }} />

    )
}